import { useState } from 'react'
import { Stack } from '@mui/material'
import { getSecondarySchema } from '@/config/navigation/secondaryNav'
import { getAllApps, getAllBoards, getTopApps, getTopBoards } from '@/data/adapters/navigationData'
import SecondaryNavAccountFooter from './components/SecondaryNavAccountFooter'
import SecondaryNavHeaderTitle from './components/SecondaryNavHeaderTitle'
import SecondaryNavShell from './components/SecondaryNavShell'
import { renderSecondaryNavSection } from './renderSecondaryNavSection'
import styles from './index.module.scss'

function SecondaryLeftNavigationView(props) {
  const [searchValue, setSearchValue] = useState('')
  const schema = getSecondarySchema(props.activeKey)
  const currentView = props.activeView ?? schema.initialView
  const sections = schema.views[currentView] ?? []
  const sectionCtx = {
    index: 0,
    activeKey: props.activeKey,
    searchValue,
    setSearchValue,
    topBoards: getTopBoards(5),
    allBoards: getAllBoards(),
    topApps: getTopApps(5),
    allApps: getAllApps(),
    ...props,
  }

  return (
    <SecondaryNavShell collapsedForRail={props.collapsedForRail}>
      <Stack className={styles.shellColumn} direction="column">
        <Stack className={styles.stack} direction="column">
          <SecondaryNavHeaderTitle title={schema.headerTitle} highlighted={schema.highlighted} />
          {sections.map((section, index) =>
            renderSecondaryNavSection(section, { ...sectionCtx, index }),
          )}
        </Stack>
        <SecondaryNavAccountFooter
          onAccountMenuAction={props.onAccountMenuAction}
          accountFullName={props.accountFullName}
          accountEmail={props.accountEmail}
        />
      </Stack>
    </SecondaryNavShell>
  )
}

export default SecondaryLeftNavigationView
